module.exports = __webpack_public_path__ + "media/images/item/cart_btn-333596c521c9554872515396d727abbb.gif";